exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ds-card-link{align-self:start;color:var(--ds-color-london-10);font-family:var(--ds-type-system-sans-lining);font-size:var(--ds-type-scale-0);font-weight:400;line-height:var(--ds-type-leading-lower);margin-top:.25rem;outline:solid transparent}.ds-card-link:focus{background-color:var(--ds-color-chicago-95)}.ds-card-link:hover{background-color:transparent;color:var(--ds-color-chicago-30);text-decoration:none}.ds-card-link:active{background-color:var(--ds-color-chicago-95);text-decoration:none}", ""]);

// exports
exports.locals = {
	"ds-card-link": "ds-card-link"
};